import { Cookie } from "constants/cookies";
import { getCookie, setCookie } from "helpers/cookies";
import { getFragmentParam, getRootDomain } from "helpers/url";
import { IKeyAny } from "services/api/api-client";

import { deserializeAccountsStateParam } from "./routing";

export enum Scope {
  RolesAllRw = "roles--all:rw",
  AccountsMyRw = "accounts--my:rw",
  SessionsMyRw = "sessions--my:rw",
  AccountsAllRo = "accounts--all:ro",
  AccountsAllRw = "accounts--all:rw",
  AccountsRolesAllRw = "accounts.roles--all:rw",
  AccountsRolesHdAllRc = "accounts.roles.hd--all:rc",
  AccountsRolesHdAllRw = "accounts.roles.hd--all:rw",
  SubscriptionSeatHdRw = "subscription.seat.hd:rw",
  SubscriptionHdRw = "subscription.hd:rw",
}

export interface ICredentials {
  accessToken: string;
  scopes: Scope[];
}

export function parseScopesString(scopesString: string): string {
  return scopesString.replace(/([^-])-([^-])/g, "$1--$2");
}

export function getCredentialsFromFragment(): ICredentials {
  const accessToken = getFragmentParam("access_token");
  if (accessToken) {
    const scopesString = parseScopesString(getFragmentParam("scope") || "");
    const scopes = scopesString.split(",") as Scope[];
    return { accessToken, scopes };
  }
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'ICredential... Remove this comment to see the full error message
  return null;
}

export function getCredentialsFromCookies(): ICredentials {
  const accessToken = getCookie(Cookie.AccessToken);
  if (accessToken) {
    const scopesString = parseScopesString(getCookie(Cookie.Scopes)) || "";
    const scopes = scopesString.split(",") as Scope[];
    return { accessToken, scopes };
  }
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'ICredential... Remove this comment to see the full error message
  return null;
}

export function getDeserializedStateFromFragment(): IKeyAny {
  // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
  return deserializeAccountsStateParam(getFragmentParam("state"));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function saveCredentialCookies(credentials: ICredentials) {
  // Assign cookie to root domain so that it is accessible across other subdomains
  const domain = getRootDomain();

  setCookie(Cookie.AccessToken, credentials.accessToken, {
    days: 14,
    path: "/",
    domain,
    secure: true,
  });

  setCookie(Cookie.Scopes, credentials.scopes.join(","), {
    days: 14,
    path: "/",
    domain,
  });
}
